<template>
  <!-- <div style="display: flex;z-index: 99999999999;position: relative;">
    <p><button @click="upproducts()">上传产品</button></p>
    <br><br><br><br><br>
    <div>
      <p><button @click="upIndexPic('pAreaImgFiles','productId',)">上传图片</button></p>
    </div>
    <p></p>
    <div>
      <p><button @click="upproducts()">上传产品</button></p>
    </div>
    <div>
      <p><button @click="upproducts99()">+++++++++++++++++++++++++++++++++++上传产品</button></p><br><br><br><br><br>
    </div>
  </div> -->
</template>

<script>
  import {
    mapActions
  } from 'vuex';
  import api from "../../utils/api";
  import {
    aGet,
    aPost,
    upImg2
  } from "../../utils/request";
  import axios from 'axios';
  import indexedDB from "../../indexedDB";
  import {
    get
  } from 'http';
  export default {
    name: "nonetup",
    data() {
      return {
        // userAddress: {
        // 'base64':null
        // },
        myApiBase: this.$api.apiBase,
        //  myApiBase:'http://192.168.31.178:10100/',
      }
    },
    created() {
      console.log('created::::upproducts()')
      if (navigator.onLine) {
        this.upproducts();
      }
    },
    methods: {
      async upproducts99() {
        var that = this
        var pvF = await indexedDB.dbOperation('pVideoFiles', 'get', 1070);
        console.log('pvF', pvF)
        await that.base64ConvertFile(pvF.productVideo, that.random32bit()).then(async (voidFile) => {
          console.log(voidFile)
          let parma = {
            storeId: 241,
            file: voidFile
          }
          console.log(parma)
          await upImg2(api.upload, {
            storeId: 241,
            file: voidFile
          }).then(res => {
            if (res.data.code == 0) {}
            console.log('视频信息Test', res.data.url);
          })

        })

      },
      base64ToFile(fileByte, fileName) {
        // 下载文件
        var arr = fileByte.split(',')
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blob = new Blob([u8arr], {
          type: ""
        });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download = fileName;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        }
      },
      async base64ConvertFile(urlData, filename) { // 64转file
        const response = new Promise((resolve, reject) => {
          var arr = urlData.split(',')
          var type = arr[0].match(/:(.*?);/)[1]
          var fileExt = type.split('/')[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          let blob = new Blob([u8arr], {
            type: type
          });
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(blob, filename + '.' + fileExt);
          // } else {
          //   let downloadElement = document.createElement("a");
          //   let href = window.URL.createObjectURL(blob);
          //   downloadElement.href = href;
          //   downloadElement.download = filename + '.' + fileExt;
          //   document.body.appendChild(downloadElement);
          //   downloadElement.click();
          //   document.body.removeChild(downloadElement);
          //   window.URL.revokeObjectURL(href);
          // }

          resolve(new File([blob], filename + '.' + fileExt, {
            type: type
          }))
        })
        return response
      },
      random32bit() {
        let u = new Uint32Array(1);
        window.crypto.getRandomValues(u);
        let str = u[0].toString(16).toUpperCase();
        return '00000000'.slice(str.length) + str;
      },
      // 上传更新的产品
      async upproducts() {
        console.log("子组件方法")
        var that = this;
        const rs = await indexedDB.dbOperation('productDetailS', 'getAll');
        if (rs == '') {
          localStorage.setItem('up', 'ok');
        } else {
          rs.forEach(async (v, i) => {
            //更新产品视频 pVideoFiles 下载离线时没有视频的时候会 undefined /*/ 只要本地离线上传过一次 pvF.productVideo != null 删除视频后 pvF.productVideo == null
            // pvF.url = null 说明等待上传
            var pvF = await indexedDB.dbOperation('pVideoFiles', 'get', v.productId);
            console.log('pvF', pvF)
            if (pvF != undefined && pvF.productVideo != null && pvF.url == null) {
              // 创建File对象
              await that.base64ConvertFile(pvF.productVideo, that.random32bit()).then(async (voidFile) => {
                let parma = {
                  storeId: v.tProduct.storeId,
                  file: voidFile
                }
                console.log(parma)
                await upImg2(api.upload, {
                  storeId: v.tProduct.storeId,
                  file: voidFile
                }).then(res => {
                  if (res.data.code == 0) {
                    pvF.url = res.data.url
                    v.tProduct.productVideo = res.data.url
                    that.updates("pVideoFiles", pvF);
                  }
                  console.log('视频信息upproducts', res.data.url);
                })

              })

            }
            await that.upIndexPic('pImgFiles', 'productId', v.productId);
            await that.upIndexPic('pAreaImgFiles', 'productId', v.productId);
            // await this.upIndexPic('productCover','productId',v.productId);
            const rs1 = await indexedDB.getindex('pImgFiles', 'productId', v.productId);
            const rs2 = await indexedDB.getindex('pAreaImgFiles', 'productId', v.productId);
            // const rs3 = await indexedDB.getindex('productCover','productId',v.productId);
            var imgurl = "";
            var imgurl2 = "";
            var urlb = '';
            if (rs1 != '') {
              urlb = rs1[0].url;
              rs1.forEach(async (v1, i1) => {
                if (i1 == 0) {
                  imgurl = v1.url;
                } else {
                  imgurl = imgurl + "," + v1.url;
                }
              });
            }
            if (rs2 != '') {
              rs2.forEach(async (v2, i2) => {
                if (i2 == 0) {
                  imgurl2 = v2.url;
                } else {
                  imgurl2 = imgurl2 + "," + v2.url;
                }
              });
            }
            //  alert('imgurl',imgurl);
            console.log('urlb', urlb);
            if (urlb) {
              v.tProduct.productImgs = imgurl;
              v.tProduct.productAreaImg = imgurl2;
              // v.tProduct.productImgs=imgurl3;

              var pv = await indexedDB.dbOperation('pVideoFiles', 'get', v.productId);
              v.tProduct.productVideo = pv.url

              let dat = v.tProduct;
              dat = JSON.stringify(dat);
              let da = new FormData();
              da.append('tProduct', dat);
              axios.post(that.myApiBase + '/product/saveProduct', da)
                .then(res => {
                  // console.log('u3',res);
                  if (res.data.msg == '操作成功') {
                    //上传成功，删除本地临时表
                    indexedDB.delindex('productDetailS', v.productId);
                    localStorage.setItem('up', 'ok');
                  }
                })
            }
          })
        }
      },
      //索引上视频
      async upIndexVideo(st, index, pid) {
        var that = this;
        const rs = await indexedDB.getindex(st, index, pid);
        upImg2(api.upload, parma).then(res => {
          if (res.data.code == 0) {}
          console.log('视频信息', res.data.url);
        })
      },
      //索引上传图
      async upIndexPic(st, index, pid) {
        var that = this;
        const rs = await indexedDB.getindex(st, index, pid);
        rs.forEach(async (v, i) => {
          // console.log('v',v);
          let userAddress = {};
          userAddress.base64 = v.imgFiles;
          let parma = userAddress;
          // console.log('b60004',userAddress);
          await axios.post(that.myApiBase + '/upload/uploadBase64', parma).then(res => {
            var url = res.data.data.url;
            //  console.log('url',url);
            v.url = url;
            that.updates(st, v);
          })
        })
      },
      //更新数据
      updates(st, dat) {
        const conn = window.indexedDB.open('tts', 1);
        conn.onsuccess = function(event) {
          var db = event.target.result;
          var request = db.transaction([st], 'readwrite').objectStore(st)
            .put(dat);
          request.onsuccess = function(event) {
            //  console.log('products更新成功');
          };
          request.onerror = function(event) {
            // console.log('products更新失败');
          }
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/nonet/nonetup.vue